import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EntregasAnalise } from '../../models/entregas-analise.model';
import { EntregasAnaliseService } from '../../services/entregas-analise.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';

@Component({
  selector: 'app-detalhe-entrega-projeto-analise-list',
  templateUrl: './detalhe-entrega-projeto-analise-list.component.html',
  styleUrls: ['./detalhe-entrega-projeto-analise-list.component.scss']
})
export class DetalheEntregaProjetoAnaliseListComponent extends BaseListComponent<EntregasAnalise> implements OnInit, OnDestroy {

  @Input() idEntrega: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  analiseList: EntregasAnalise[];
  getAnalise: any;
  viewLastAnalises: boolean = false;

  constructor(
    private myService: EntregasAnaliseService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.addSub(
      this.myService.getList(this.idEntrega).subscribe((res) => {
        this.getAnalise = res;
        this.analiseList = this.getAnalise?.analysis;
        this.loaded();
      })
    );
  }

  viewLast() {
    this.viewLastAnalises = !this.viewLastAnalises
  }

  confirmExcluir(id: number) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number) {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation().subscribe(() => {
          this.initList();
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

}
